module.exports = __webpack_public_path__ + "img/1.be0047d5.svg";